import { render, staticRenderFns } from "./DrugOrdersInboxValidation.vue?vue&type=template&id=9ce96b7e&"
import script from "./DrugOrdersInboxValidation.vue?vue&type=script&lang=js&"
export * from "./DrugOrdersInboxValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports